import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
    Form,
    Input,
    Tooltip,
    Icon,
    // Cascader,
    // AutoComplete,
    Avatar,
    Modal,
    Upload,
} from "antd";
import agent from "agent";

import ListErrors from "components/ListErrors";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class UserModal extends React.Component {
    static propTypes = {
        visible: PropTypes.bool,
        onUserModalOk: PropTypes.func,
        onUserModalCancel: PropTypes.func,
    };
    state = {
        fileList: [],
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!nextProps.visible) {
            return { fileList: [] };
        }
        return null;
    }

    handleSubmit = e => {
        e.preventDefault();
    };
    handleUserModalOk = e => {
        const { user, form, onUserModalOk, onUserModalCancel } = this.props;
        form.validateFieldsAndScroll((err, values) => {
            // check password
            if (values.password || values.confirm) {
                if (!values.password || values.password.length < 6) {
                    form.setFields({
                        password: {
                            value: values.password,
                            errors: [
                                new Error(
                                    `password must be at least 6 chars long`
                                ),
                            ],
                        },
                    });
                    return;
                }
                if (values.confirm !== values.password) {
                    form.setFields({
                        confirm: {
                            value: values.confirm,
                            errors: [
                                new Error(
                                    `Two passwords that you enter is inconsistent`
                                ),
                            ],
                        },
                    });
                    return;
                }
            }

            if (!err) {
                const send = {};
                if (values.password) {
                    send.password = values.password;
                }
                const sendKeys = ["phone", "email", "nickname", "avatar"];
                for (const key of sendKeys) {
                    if (values[key] != user[key]) {
                        send[key] = values[key];
                    }
                }
                // update avatar
                const { fileList } = this.state;
                if (fileList.length) {
                    send.avatar = fileList[0];
                }

                if (Object.keys(send).length) {
                    onUserModalOk({ ...send, userid: user.userid });
                } else {
                    onUserModalCancel();
                }
            }
        });
    };
    handleDeleteAvatarClick = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.setFields({
            avatar: {
                value: "",
            },
        });
    };

    render() {
        const {
            visible,
            confirmLoading,
            user,

            onUserModalCancel,
        } = this.props;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tltle = user.userid ? `Edit user: ${user.userid}` : `Create User`;
        const { fileList } = this.state;
        const uploadProps = {
            onRemove: file => {
                this.setState(state => {
                    return {
                        fileList: [],
                    };
                });
                this.props.form.setFields({
                    avatar: {
                        value: user.avatar,
                    },
                });
            },
            beforeUpload: file => {
                this.setState(state => ({
                    fileList: [file],
                }));
                getBase64(file).then(data => {
                    this.props.form.setFields({
                        avatar: {
                            value: data,
                        },
                    });
                });

                return false;
            },
            accept: "image/*",
            listType: "picture",
            fileList,
        };
        return (
            <Modal
                title={tltle}
                centered
                destroyOnClose
                confirmLoading={confirmLoading}
                visible={visible}
                onOk={this.handleUserModalOk}
                onCancel={onUserModalCancel}
            >
                <ListErrors errors={this.props.errors} />

                <Form onSubmit={this.handleSubmit}>
                    <div style={{ textAlign: "center", marginBottom: " 30px" }}>
                        {getFieldDecorator("avatar", {
                            rules: [
                                {
                                    required: false,
                                },
                            ],
                            initialValue: user.avatar,
                        })(<Input type="hidden" />)}
                        <Upload {...uploadProps}>
                            <Avatar
                                key={getFieldValue("avatar")}
                                size={64}
                                icon="user"
                                src={agent.getApiUrl(getFieldValue("avatar"))}
                            />
                        </Upload>
                        {fileList.length == 0 && (
                            <Link
                                style={{ display: "block" }}
                                to="#"
                                onClick={this.handleDeleteAvatarClick}
                            >
                                Delete
                            </Link>
                        )}
                    </div>
                    <Form.Item {...formItemLayout} label="E-mail">
                        {getFieldDecorator("email", {
                            rules: [
                                {
                                    required: false,
                                    type: "email",
                                    message: "The input is not valid E-mail!",
                                },
                            ],
                            initialValue: user.email,
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="Phone Number">
                        {getFieldDecorator("phone", {
                            rules: [
                                {
                                    required: false,
                                    pattern: /^\d*$/,
                                    message:
                                        "The input is not valid Phone Number!",
                                },
                            ],
                            initialValue: user.phone,
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="Password">
                        {getFieldDecorator("password", {
                            rules: [
                                {
                                    required: false,
                                    message: "Please input your password!",
                                },
                            ],
                        })(<Input type="password" />)}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="Confirm Password">
                        {getFieldDecorator("confirm", {
                            rules: [
                                {
                                    required: false,
                                    message: "Please confirm your password!",
                                },
                            ],
                        })(<Input type="password" />)}
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label={
                            <span>
                                Nickname&nbsp;
                                <Tooltip title="What do you want others to call you?">
                                    <Icon type="question-circle-o" />
                                </Tooltip>
                            </span>
                        }
                    >
                        {getFieldDecorator("nickname", {
                            rules: [
                                {
                                    required: false,
                                    message: "Please input your nickname!",
                                    whitespace: true,
                                },
                            ],
                            initialValue: user.nickname,
                        })(<Input />)}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default Form.create({ name: "UserModal" })(UserModal);
